import toastBus from './toastBus'

const toast = {
  success: (message: string, title?: string) => toastBus.success(message, title),
  error: (message: string, title?: string) => toastBus.error(message, title),
  info: (message: string, title?: string) => toastBus.info(message, title),
  warning: (message: string, title?: string) => toastBus.warning(message, title),
}

export type { ToastType, ToastEvent } from './toastBus'
export default toast
